<ng-container *ngIf="vm$ | async as vm">
  <ng-container *ngIf="!!vm.typeFilterConfig.length">
    <button
      #filterToggle
      [dgxPopoverTrigger]="filterPopover"
      data-dgat="search-filter-575"
      type="button"
      df-button
      dfButtonType="passive"
      class="collection-filter-btn btn guts-p-h-1"
      [ngClass]="{
        'collection-filter-btn--selected': !!filterItems.type.length
      }"
    >
      <span
        [ngClass]="{
          'collection-filter-btn--label': !filterItems.type.length,
          'collection-filter-btn--selected--label': !!filterItems.type.length
        }"
      >
        {{ i18n.UserController_Type }}
      </span>

      <span
        class="num-selected-filters guts-p-l-half"
        *ngIf="filterItems.type.length > 0"
        >{{ filterItems.type.length }}</span
      >
      <df-icon
        [ngClass]="{
          'collection-filter-btn--icon-': !filterItems.type.length,
          'collection-filter-btn--icon--selected': !!filterItems.type.length
        }"
        icon="chevron-down"
        size="small"
        class="guts-p-l-quart guts-m-l-half"
      ></df-icon>
    </button>

    <dgx-popover
      #filterPopover
      [isOpen]="isPopoverOpen"
      (isOpenChange)="popoverToggled($event)"
      [popoverArrowHidden]="true"
      [appendToBody]="true"
      placement="bottom-left"
    >
      <div class="overflow-scroll-gradient">
        <div
          class="
            overflow-scroll-gradient__scroller
            guts-p-h-1-half guts-p-b-2
            rel
            l_flex
          "
        >
          <div
            class="filter-items full-height no-wrap guts-p-r-6"
            *ngFor="let filter of vm.typeFilterConfig; let last = last"
            data-dgat="type-facet-filter-75f"
          >
            <div
              class="
                par--small
                font-semibold
                guts-p-h-half guts-p-b-half guts-p-t-1-half
              "
              [ngClass]="{ 'guts-p-r-2-half': !last }"
            >
              {{ filter.title }}
            </div>
            <div
              [attr.aria-label]="filter.title"
              [attr.aria-multiselectable]="true"
              [closeOnSelect]="false"
              [closeOnTab]="false"
              class="cursor-pointer"
              role="listbox"
              [id]="'typeFilterItem' + filter.name"
            >
              <!-- role="option" elements must be immediate children of the role="listbox" element -->
              <button
                *ngFor="let filterItem of filter.items"
                role="option"
                class="
                  listbox--option
                  filter-hover
                  guts-p-h-1
                  l_flex l_flex-middle
                  cursor-pointer
                "
                [attr.aria-selected]="
                  filterItems.type.includes(filterItem.name)
                "
                (click)="typeToggled($event, filterItem)"
                [attr.aria-pressed]="filterItems.type.includes(filterItem.name)"
                [id]="'typeFilterItem' + filterItem.name"
                [disabled]="vm.status.filterUpdating"
                data-dgat="type-facet-filter-42c"
              >
                <input
                  type="checkbox"
                  tabindex="-1"
                  readonly="readonly"
                  class="guts-m-r-1"
                  [checked]="filterItems.type.includes(filterItem.name)"
                  data-dgat="type-facet-filter-b62"
                />
                <label class="cursor-pointer font-medium">
                  {{ filterItem.displayName }}
                </label>
              </button>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div
          class="
            l_flex l_flex-column l_flex-justify-right l_flex-middle
            guts-p-full-2
          "
        >
          <button
            df-button
            dfButtonType="primary"
            data-dgat="type-facet-filter-e73"
            (click)="closePopover()"
            [disabled]="vm.status.filterUpdating"
            class="guts-m-b-1-quart full-width"
          >
            {{ i18n.Core_ShowResults }}
          </button>

          <button
            class="
              color-blue
              par--small
              font-medium
              uhover
              guts-m-r-1-half
              full-width
            "
            (click)="resetType()"
            [attr.aria-label]="i18n.dgProfileOverview_ViewAllSkills"
            data-dgat="type-facet-filter-684"
            [disabled]="vm.status.filterUpdating"
          >
            {{ vm.clearButtonsCopy.type }}
          </button>
        </div>
      </div>
    </dgx-popover>
  </ng-container>
</ng-container>
